module.exports = __webpack_public_path__ + "1_0_61/img/Taj Mahal.14810486.jpg";